import React from 'react';

import classnames from 'classnames';
import { connect } from 'react-redux';

import { MODALS } from 'global-constants';

import image from 'assets/images/homepage/analytics.png';

import { openModal } from 'shared/components/Modals/reducer';

import Image from 'shared/components/Image';
import Button from 'shared/components/Button';

import styles from './styles.module.scss';

const Analytics = ({ className, openModal }) => (
  <div className={classnames('container', styles.container, className)}>
    <div className="remove-sm">
      <Image src={image} height="515" width="612" />
    </div>
    <div className="remove-md-min">
      <Image src={image} width="100%" />
    </div>
    <div className={styles.right}>
      <div className={styles.title}>Tap into our data & analytics</div>
      <div className={styles.description}>
        The power of data, right at your fingertips. Access real-time analytics
        and gain insight into PropTech companies, solutions, investments and
        more. With a premium account you can fast-track your research, upscale
        your knowledge and make informed business decisions to stay ahead of the
        competition.
      </div>
      <Button
        color="orange-gradient"
        className={styles.button}
        onClick={() => openModal({ modalName: MODALS.SIGNUP })}>
        Sign up now
      </Button>
    </div>
  </div>
);

const mapStateToProps = state => ({});

const mapDispatchToProps = { openModal };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Analytics);
